import { Link } from "react-router";

function ResetPasswordSuccess() {
  return (
    <div className="card w-full max-w-md bg-base-100 shadow-xl">
      <div className="card-body items-center text-center">
        <div className="w-24 h-24 rounded-full bg-success/20 flex items-center justify-center mb-4">
          <svg className="w-12 h-12 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h2 className="card-title text-2xl font-bold text-success mb-2">Password Reset Successful!</h2>

        <p className="text-base-content/70">
          Your password has been successfully reset. You can now use your new password to log in to your account.
        </p>

        <div className="card-actions mt-6">
          <Link to="/login" className="btn btn-primary w-full">
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordSuccess;

